import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const PropertyFeatures = styled.ul`
  margin-bottom: 32px;
  overflow: hidden;
  padding-left: 16px;
  list-style: disc;
  transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1);
`

export const PropertyFeature = styled.li`
  color: ${COLORS.navi};
`

export const Readmore = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: ${COLORS.secondary};
  font-family: ${FONTS.bold};
  font-size: 14px;
  text-transform: uppercase;

  svg {
    margin-left: 6px;
  }
`
